import ZkIcon from './src/icon.vue';

/* istanbul ignore next */
ZkIcon.install = function(Vue) {
  Vue.component(ZkIcon.name, ZkIcon);
};

export default ZkIcon;



// WEBPACK FOOTER //
// ./src/packages/icon/index.js